import { useEffect, useState } from "react";
import HomePageContent from "../../components/HomePageContent";
import PageLoading from "../../components/PageLoading";
import InlineAudioPlayer from "../../components/InlineAudioPlayer";

// -------- React slick slider
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// -------- font awesome icon
import {
  faMartiniGlass as faGlass,
  faCar,
  faStar,
  faStarHalfAlt,
  faLaptop,
  faUniversity,
  faMoneyBill,
  faBan,
  faCertificate,
  faHeart,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import * as API from "../../api/api.js";
import { home } from "@/data";
import { Link } from "react-router-dom";

const Home = () => {
  const [loading, setLoading] = useState(false);
  const [slidesData, setSlidesData] = useState([]);
  const [guaranteesData, setGuaranteesData] = useState([]);
  const [lessonCards, setLessonCards] = useState([]);
  const [paragraphDetails, setParagraph] = useState(null);
  const [partnersData, setPartnersData] = useState(home.partners);

  const iconBarData = [
    {
      icon: faGlass,
      text: "DUI PROGRAM",
      href: "/dui-school",
    },
    {
      icon: faCar,
      text: "DRIVING LESSONS",
      href: "/driving-lessons",
    },
    {
      icon: faStar,
      text: "NEW DRIVER COURSE",
      href: "/florida-driving-test",
    },
    {
      icon: faLaptop,
      text: "ONLINE TRAFFIC SCHOOL",
      href: "/online-traffic-school",
    },
    {
      icon: faUniversity,
      text: "CLASSROOM TRAFFIC SCHOOL",
      href: "/classroom-traffic-school",
    },
  ];

  useEffect(() => {
    document.title = `Metro traffic School - Home `;
    getHomeDatas();
  }, []);

  const getHomeDatas = () => {
    setLoading(true);
    setSlidesData(home.slides);
    setGuaranteesData(home.guarantees);
    setLessonCards(home.cards);
    setParagraph(home.paragraph);
    setPartnersData(home.partners);
    setLoading(false);
    // Note: Old API way
    // API.getDatas("/home")
    //     .then((res) => {
    //         setLessonCards(res.data.headercard);
    //         setParagraph(res.data.paragraph);
    //         setReviews(res.data.reviews);
    //         setLoading(false);
    //     })
    //     .catch((err) => {
    //         setLoading(false);
    //     });
  };

  const iconMap = {
    "money-bill": faMoneyBill,
    ban: faBan,
    certificate: faCertificate,
    heart: faHeart,
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    fade: true,
    cssEase: "linear",
    arrows: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
    ],
  };

  return (
    <>
      <section className="hero-slider-section">
        <Slider {...settings}>
          {slidesData.map((slide, index) => (
            <div key={index}>
              <div
                className="hero-banner"
                style={{ backgroundImage: `url(${slide.image})` }}
              >
                <div className="banner-text-container">
                  <div className="banner-heading">
                    <p className="banner-subheading">{slide.line1}</p>
                    <h1 className="banner-title">{slide.line2}</h1>
                  </div>
                  <Link to={slide.link} className="banner-cta-container">
                    <span className="banner-cta-text">{slide.line3}</span>
                    <div className="banner-cta-arrow"></div>
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </Slider>

        <div className="icon-bar-container">
          {iconBarData.map((item, index) => (
            <a key={index} href={item.href} className="icon-bar-item">
              <FontAwesomeIcon icon={item.icon} className="icon-bar-icon" />
              <span className="icon-bar-text">{item.text}</span>
            </a>
          ))}
        </div>
      </section>

      <section className="guarantees-section py-4 mt-5">
        <div className="container">
          <div className="row justify-content-center">
            {guaranteesData.map((guarantee, index) => (
              <div className="col-md-3 col-sm-6 mb-4 mb-md-0" key={index}>
                <div className="guarantee-card text-center h-100">
                  <div className="guarantee-icon mb-3">
                    <FontAwesomeIcon
                      icon={iconMap[guarantee.icon]}
                      size="3x"
                      style={{ color: "var(--metro-yellow)" }}
                    />
                  </div>
                  <h4 className="guarantee-title text-white">
                    {guarantee.title}
                  </h4>
                  <p className="guarantee-text text-white-50">
                    {guarantee.text}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="courses-section py-5">
        <div className="container">
          <div className="row text-center mb-5">
            <div className="col-lg-8 mx-auto text-white">
              <h2 className="display-5 fw-bold">
                METRO <strong>TRAFFIC SCHOOL</strong>
              </h2>
              <p className="lead">
                ALL OUR COURSES ARE FLORIDA STATE CERTIFIED
              </p>
            </div>
          </div>

          <div className="row g-4">
            {lessonCards.map((card, index) => (
              <div key={index} className="col-lg-4 col-md-6">
                <div className="card text-white border-0 rounded-lg overflow-hidden course-card">
                  <img
                    src={card.imgSrc}
                    className="card-img"
                    alt={card.title}
                  />
                  <div className="card-img-overlay card-img-overlay-custom d-flex flex-column justify-content-end p-4">
                    <div>
                      <h4 className="card-title fw-bold">{card.title}</h4>
                      <p className="card-text card-body-content">
                        {card.text}
                        {card.hasAudioSample && <InlineAudioPlayer />}
                      </p>
                      <a
                        href={card.link}
                        target={card.target}
                        rel={card.target === "_blank" ? "noopener noreferrer" : undefined}
                        className="btn btn-light rounded-lg mt-3 px-4"
                        style={{
                          backgroundColor: "var(--metro-yellow)",
                          border: "none",
                        }}
                      >
                        More Info
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {!loading && paragraphDetails && (
        <HomePageContent paraDetails={paragraphDetails} />
      )}

      <div className="row text-center mb-5">
        <div className="col-lg-8 mx-auto text-white-50">
          <p className="lead text-warning">ALL OUR COURSES ARE FLORIDA STATE CERTIFIED</p>

          <div className="mt-3 mb-2 text-center text-white">
            <p className="mb-1">
              Metro Traffic School is proud to provide customer service via Live
              Chat, Phone and Email.
            </p>
            <p className="mb-1">
              We have some of the highest customer service ratings in Florida.
            </p>
            <p className="mb-0">
              <Link
                to="/reviews"
                className="text-warning fw-bold text-decoration-none"
                target="_blank"
                rel="noopener noreferrer"
              >
                Click here
              </Link>{" "}
              for some unedited customer reviews left by our students.
            </p>
          </div>

          <div className="text-center mt-4 mb-3">
            <h5 className="h-5 mb-2 text-white fw-bold">
              METRO TRAFFIC SCHOOL CUSTOMER REVIEWS
            </h5>
            <div className="d-flex justify-content-center align-items-center">
              {[1, 2, 3, 4].map((i) => (
                <FontAwesomeIcon
                  key={i}
                  icon={faStar}
                  className="me-1"
                  style={{ color: "var(--metro-yellow)" }}
                />
              ))}
              <FontAwesomeIcon
                icon={faStarHalfAlt}
                className="me-1"
                style={{ color: "var(--metro-yellow)" }}
              />
            </div>
          </div>
        </div>
      </div>

      <section className="partners-section py-2 pb-5">
        <div className="container">
          <div className="row gy-4 justify-content-center">
            {partnersData.map((partner, index) => (
              <div key={index} className="col-lg-3 col-md-6">
                <div className="card h-100 border-0 shadow-sm partner-card">
                  <a
                    href={partner.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="card-body d-flex align-items-center justify-content-center p-4"
                  >
                    <img
                      src={partner.logoUrl}
                      alt={`${partner.name} logo`}
                      className="img-fluid"
                    />
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {loading && (
        <div className="row">
          <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
            <PageLoading color={"var(--metro-yellow)"} classes={"justify-content-center"} />
          </div>
        </div>
      )}
    </>
  );
};

export default Home;
